define((require) => {
    "use strict";

    const FileDropManager   = require("services/FileDropManager");
    const ImageFileStorage  = require("services/files/ImageFileStorage");
    const ImageModel        = require("ui/assets/image/ImageModel");

    const ImageDropManager = FileDropManager.extend("ImageDropManager", {

        fileModel: ImageModel,

        /**
         * Additional fields needed for the `ImageModel` during upload.
         */
        fileModelAttributes: (name = "?", size = "?") => ({
            name,
            // `size` needed for the computed `displaySize`.
            size,
            // Include `altText` based on the filename (without extension).
            altText: name.replace(/\.[^/.]+$/, "")
        }),

        fileStorage: ImageFileStorage

    });

    // Singleton
    return new ImageDropManager();
});



// WEBPACK FOOTER //
// ./src/editor/services/ImageDropManager.js